import { useSubscription } from '../../contexts/SubscriptionContext';
import { planOwnerLabel } from './planLockTexts';

/**
 * Nome do plano atual para as mensagens de limite: "O plano Essencial",
 * "O período de teste" ou "Seu plano" quando o nome ainda não chegou.
 */
const useCurrentPlanLabel = () => {
  const { subscription, isInActiveTrial } = useSubscription();
  return planOwnerLabel({ planName: subscription?.plan_name, inTrial: isInActiveTrial() });
};

export default useCurrentPlanLabel;
